module.exports = __webpack_public_path__ + "img/main.d0139401.png";